module.exports = __webpack_public_path__ + "img/CM-SS-CA-Buick-Established.1061f02b.jpeg";